// extracted by mini-css-extract-plugin
module.exports = {"icon":"StaffTagContainer-icon-56682e4016588603658fc25987f48bb7","tag":"StaffTagContainer-tag-340d603f1c7d713e731053756346987c"};